import Feature from 'ol/Feature';
import GeoJSON from 'ol/format/GeoJSON';

const fromGeometry = (geometry) => {
	return new Feature({
		geometry: geometry
	});
}	

const fromGeoJSON = (text, projection) => new GeoJSON().readFeatures(text, {
	dataProjection: projection
});

const feature = {
	fromGeometry, fromGeoJSON
};

export {
	feature
}